import React from 'react';
import { Link } from 'react-router-dom';

export function UpskillSection() {
  const services = [
    {
      title: "Personal Career Coach",
      icon: "https://otfbpcicwhfqgupzvoyx.supabase.co/storage/v1/object/public/media/uploads/career%20c.png", // Replace with your actual icon URL
    },
    {
      title: "Resume Scoring & Review",
      icon: "https://otfbpcicwhfqgupzvoyx.supabase.co/storage/v1/object/public/media/uploads/Resume.png", // Replace with your actual icon URL
    },
    {
      title: "Upskill w/ our Course Market",
      icon: "https://otfbpcicwhfqgupzvoyx.supabase.co/storage/v1/object/public/media/uploads/course%20market.png", // Replace with your actual icon URL
    },
    {
      title: "Career Progress Tracker",
      icon: "https://otfbpcicwhfqgupzvoyx.supabase.co/storage/v1/object/public/media/uploads/tracker.png", // Replace with your actual icon URL
    },
    {
      title: "Private Job Board",
      icon: "https://otfbpcicwhfqgupzvoyx.supabase.co/storage/v1/object/public/media/uploads/job%20boad.png", // Replace with your actual icon URL
    },
    {
      title: "Events & Live Workshops",
      icon: "https://otfbpcicwhfqgupzvoyx.supabase.co/storage/v1/object/public/media/uploads/Events.png", // Replace with your actual icon URL
    },
    {
      title: "Community",
      icon: "https://otfbpcicwhfqgupzvoyx.supabase.co/storage/v1/object/public/media/uploads/communi.png", // Replace with your actual icon URL
    },
    {
      title: "Private Blog & Advice",
      icon: "https://otfbpcicwhfqgupzvoyx.supabase.co/storage/v1/object/public/media/uploads/blog.png", // Replace with your actual icon URL
    },
    {
      title: "Live Layoff Tracker",
      icon: "https://otfbpcicwhfqgupzvoyx.supabase.co/storage/v1/object/public/media/uploads/Layoff.png", // Replace with your actual icon URL
    }
  ];

  return (
    <section className="flex bg-[#afa492]">
      {/* Left side with image */}
      <div className="w-1/2 relative hidden md:block">
        <img 
          src="https://otfbpcicwhfqgupzvoyx.supabase.co/storage/v1/object/public/media/uploads/IMG_4011.jpg"
          alt="Person working"
          className="w-full h-auto object-contain"
          style={{ maxHeight: '100%' }}
        />
      </div>
      
      {/* Right side with content */}
      <div className="w-full md:w-1/2 py-12 px-8 md:px-12">
        <h1 
          className="text-4xl md:text-5xl mb-16 text-[#3a1616] text-center"
          style={{ fontFamily: "'Playfair Display', serif" }}
        >
          How TZLY Career Labs Transforms You
        </h1>
        
        {/* Services grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-4 gap-y-12 mb-12">
          {services.map((service, index) => (
            <div key={index} className="flex flex-col items-center text-center">
              <div className="w-16 h-16 mb-4">
                <img 
                  src={service.icon}
                  alt={service.title}
                  className="w-full h-full"
                />
              </div>
              <h3 className="text-sm font-medium text-[#3a1616]">{service.title}</h3>
            </div>
          ))}
        </div>
        
        {/* CTA Button */}
        <div className="text-center mt-8">
          <Link 
            to="/create-account"
            className="inline-block px-12 py-4 text-white bg-[#081b1e] rounded hover:bg-opacity-90 transition-colors text-lg"
          >
            Start Your Career Transformation
          </Link>
        </div>
      </div>
    </section>
  );
}